// Analytics module page-level translations
export default {
  // ── Common ────────────────────────────────────────────
  'pages.analysis.enabled': 'Enabled',
  'pages.analysis.disabled': 'Disabled',
  'pages.analysis.total': 'Total Records',
  'pages.analysis.export': 'Export',
  'pages.analysis.view': 'View',
  'pages.analysis.more': 'More',
  'pages.analysis.collapse': 'Collapse',
  'pages.analysis.queryCondition': 'Query Conditions',
  'pages.analysis.filterCondition': 'Filter Conditions',
  'pages.analysis.exportLoading': 'Fetching export data, please wait…',
  'pages.analysis.exportFetchError': 'Failed to fetch export data',
  'pages.analysis.exportNoData': 'No data to export',
  'pages.analysis.exportSuccess': 'Export successful',
  'pages.analysis.exportFailed': 'Export failed, please try again',
  'pages.analysis.generatedAt': 'Generated: ',
  'pages.analysis.exportFailedSimple': 'Export failed',
  'pages.analysis.exportOptionExcel': 'Excel (.xlsx)',
  'pages.analysis.exportOptionCsv': 'CSV (.csv)',
  'pages.analysis.exportOptionPdf': 'PDF (.pdf)',
  'pages.analysis.range.to': 'to',
  'pages.analysis.range.from': 'from',
  'pages.analysis.range.all': 'All',
  'pages.analysis.search.placeholderKeyword': 'Enter keyword (account/nickname/company/department)',
  'pages.analysis.search.placeholderUser': 'Enter user account/nickname',
  'pages.analysis.search.placeholderUserAccount': 'Enter user account',
  'pages.analysis.search.placeholderCompany': 'Please select a company',
  'pages.analysis.search.placeholderDepartment': 'Please select a department',
  'pages.analysis.search.placeholderCompanyInput': 'Enter company',
  'pages.analysis.search.placeholderDepartmentInput': 'Enter department',
  'pages.analysis.search.placeholderRole': 'Please select a role',

  // ── Common field labels ────────────────────────────────
  'pages.analysis.field.userId': 'User ID',
  'pages.analysis.field.userAccount': 'Account',
  'pages.analysis.field.userNickname': 'Name',
  'pages.analysis.field.company': 'Company',
  'pages.analysis.field.department': 'Department',
  'pages.analysis.field.role': 'Role',
  'pages.analysis.field.status': 'Status',
  'pages.analysis.field.createTime': 'Created At',
  'pages.analysis.field.updateTime': 'Last Updated At',
  'pages.analysis.field.app': 'App',
  'pages.analysis.field.appId': 'App ID',
  'pages.analysis.field.appName': 'App Name',
  'pages.analysis.field.appType': 'App Type',
  'pages.analysis.field.appStatus': 'App Status',
  'pages.analysis.field.appCreator': 'App Creator',
  'pages.analysis.field.tokenUsed': 'Token Usage',
  'pages.analysis.field.userCount': 'Users',
  'pages.analysis.field.operation': 'Actions',
  'pages.analysis.field.unionQuery': 'Combined Search',
  'pages.analysis.field.user': 'User',
  'pages.analysis.field.terminal': 'Terminal',
  'pages.analysis.field.accessTime': 'Access Time',
  'pages.analysis.field.terminalAdmin': 'Admin Portal',
  'pages.analysis.field.terminalApp': 'App Center',
  'pages.analysis.field.modelSource': 'Model Source',
  'pages.analysis.field.inputTokens': 'Input Tokens',
  'pages.analysis.field.outputTokens': 'Output Tokens',
  'pages.analysis.field.rawTokens': 'Raw Tokens',
  'pages.analysis.field.tokenTotal': 'Total Token Usage',
  'pages.analysis.field.creator': 'Creator',
  'pages.analysis.field.updater': 'Last Updater',
  'pages.analysis.field.email': 'Email',
  'pages.analysis.field.featureTree': 'Feature Tree',
  'pages.analysis.field.permCode': 'Permission Code',
  'pages.analysis.field.featurePerm': 'Feature Permissions',

  // ── App Access Statistics (access/app) ────────────────
  'pages.analysis.accessApp.statusActive': 'Active',
  'pages.analysis.accessApp.statusInactive': 'Inactive',
  'pages.analysis.accessApp.placeholderApp': 'Please select an app',
  'pages.analysis.accessApp.reportTitle': 'App Access Statistics',

  // ── App Access Details (access/app/detail) ────────────
  'pages.analysis.accessAppDetail.title': 'App Access Details',
  'pages.analysis.accessAppDetail.useTime': 'Usage Period',
  'pages.analysis.accessAppDetail.appDesc': 'App Description',
  'pages.analysis.accessAppDetail.appInfo': 'App Info',
  'pages.analysis.accessAppDetail.accessLog': 'Access Log',

  // ── Menu Action Report (access/action) ────────────────
  'pages.analysis.accessAction.actionId': 'Action ID',
  'pages.analysis.accessAction.actionMenu': 'Action Menu',
  'pages.analysis.accessAction.type': 'Type',
  'pages.analysis.accessAction.menuType': 'Menu',
  'pages.analysis.accessAction.buttonType': 'Button',
  'pages.analysis.accessAction.operationTime': 'Action Time',
  'pages.analysis.accessAction.actionRecord': 'Action Records',
  'pages.analysis.accessAction.reportTitle': 'Menu Action Report',

  // ── System Access Report (access/login) ───────────────
  'pages.analysis.accessLogin.account': 'Account',
  'pages.analysis.accessLogin.nickname': 'Nickname',
  'pages.analysis.accessLogin.company': 'Company',
  'pages.analysis.accessLogin.loginDateTime': 'Login Date & Time',
  'pages.analysis.accessLogin.logoutDateTime': 'Logout Date & Time',
  'pages.analysis.accessLogin.loginIp': 'Login IP',
  'pages.analysis.accessLogin.duration': 'Duration',
  'pages.analysis.accessLogin.loginSuccess': 'Login Success',
  'pages.analysis.accessLogin.loginFailed': 'Login Failed',
  'pages.analysis.accessLogin.loginTime': 'Login Time',
  'pages.analysis.accessLogin.logoutTime': 'Logout Time',
  'pages.analysis.accessLogin.loginRecord': 'Login Records',
  'pages.analysis.accessLogin.reportTitle': 'System Access Report',
  'pages.analysis.accessLogin.minuteUnit': 'min',
  'pages.analysis.accessLogin.chartDuration': 'Access Duration (min)',

  // ── App Permission Report (audit/app) ─────────────────
  'pages.analysis.auditApp.title': 'App Permission Report',
  'pages.analysis.auditApp.pleaseSelectApp': 'Please select an app first',
  'pages.analysis.auditApp.permData': 'Permission Data',

  // ── User Permission Report (audit/user) ───────────────
  'pages.analysis.auditUser.title': 'User Permission Report',
  'pages.analysis.auditUser.pleaseSelectUser': 'Please select a user',
  'pages.analysis.auditUser.queryFailed': 'Query failed',
  'pages.analysis.auditUser.btnQuery': 'View',
  'pages.analysis.auditUser.btnEdit': 'Edit',
  'pages.analysis.auditUser.btnDelete': 'Delete',
  'pages.analysis.auditUser.btnAdd': 'Add',
  'pages.analysis.auditUser.btnExport': 'Export',
  'pages.analysis.auditUser.btnPrint': 'Print',
  'pages.analysis.auditUser.searchPlaceholder': 'Search by menu name or path',
  'pages.analysis.auditUser.userInfo': 'User Info',

  // ── Role Permission Report (audit/role-assign) ────────
  'pages.analysis.auditRoleAssign.title': 'Role Permission Report',
  'pages.analysis.auditRoleAssign.pleaseSelectRole': 'Please select a role first',
  'pages.analysis.auditRoleAssign.authData': 'Permission Data',

  // ── Role Permission Details (audit/role-detail) ───────
  'pages.analysis.auditRoleDetail.title': 'Role Permission Details',
  'pages.analysis.auditRoleDetail.loadRoleDetailFailed': 'Failed to load role details',
  'pages.analysis.auditRoleDetail.loadMenuPermFailed': 'Failed to load menu permissions',
  'pages.analysis.auditRoleDetail.btnQuery': 'View',
  'pages.analysis.auditRoleDetail.btnEdit': 'Edit',
  'pages.analysis.auditRoleDetail.btnDelete': 'Delete',
  'pages.analysis.auditRoleDetail.btnAdd': 'Add',
  'pages.analysis.auditRoleDetail.btnExport': 'Export',
  'pages.analysis.auditRoleDetail.btnPrint': 'Print',
  'pages.analysis.auditRoleDetail.roleName': 'Role Name',
  'pages.analysis.auditRoleDetail.roleId': 'Role ID',
  'pages.analysis.auditRoleDetail.remark': 'Remarks',
  'pages.analysis.auditRoleDetail.associatedCompany': 'Associated Companies',
  'pages.analysis.auditRoleDetail.searchPlaceholder': 'Search by menu name or permission code',
  'pages.analysis.auditRoleDetail.roleInfo': 'Role Info',
  'pages.analysis.auditRoleDetail.pleaseSelectRole': 'Please select a role',
};
